<div style="padding:24px 32px 0">
    <app-recycle-bin-base-info [item]="data"></app-recycle-bin-base-info>
</div>
